export class NotifyMessage {
  openModal: boolean;
  messageDescription: string;
  redirectTo: string;
  fascicoloId: string;
  doppiaScelta: boolean;
  callbackConfirm: boolean;
  redirect: boolean;
  title: string;

  constructor(openModal: boolean, messageDescription: string, redirectTo: string, fascicoloId: string, doppiaScelta: boolean, callbackConfirm: boolean, redirect: boolean, title: string) {
    this.openModal = openModal;
    this.messageDescription = messageDescription;
    this.redirectTo = redirectTo;
    this.fascicoloId = fascicoloId;
    this.doppiaScelta = doppiaScelta;
    this.callbackConfirm = callbackConfirm;
    this.redirect = redirect;
    this.title = title;
  }
}
